<template>
  <v-container
    id="dashboard"
    tag="section"
  >
    <v-row class="elevation-5">
      <!--      already have address-->
      <v-col
        v-if="hasLocation"
        cols="12"
        sm="6"
      >
        <v-card
          flat
          style="height: 85%"
          class="px-3"
        >
          <v-row>
            <v-col
              cols="12"
            >
              <div class="section-subheader text-center">
                Service Location
              </div>
            </v-col>
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="calculatedStreet"
              >
                <template v-slot:label>
                  <div class="lbl-lg-textbox">
                    Street Address
                  </div>
                </template>
              </v-text-field>
            </v-col>
            <v-col
              cols="6"
            >
              <v-text-field
                v-model="publicLocation.city"
              >
                <template v-slot:label>
                  <div class="lbl-lg-textbox">
                    City
                  </div>
                </template>
              </v-text-field>
            </v-col>
            <v-col
              cols="3"
            >
              <v-text-field
                v-model="publicLocation.state"
              >
                <template v-slot:label>
                  <div class="lbl-lg-textbox">
                    State
                  </div>
                </template>
              </v-text-field>
            </v-col>
            <v-col
              cols="3"
            >
              <v-text-field
                v-model="publicLocation.postal_code"
              >
                <template v-slot:label>
                  <div class="lbl-lg-textbox">
                    Zip
                  </div>
                </template>
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              class="mb-n5"
            >
              <v-btn
                block
                class="btn-bold orange lighten-2 pb-0"
                style="color: #333333"
                @click="doResetLocation"
              >
                RESET LOCATION
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              class="mb-n5"
            >
              <v-btn
                block
                class="btn-bold orange lighten-2 pb-0"
                style="color: #333333"
                @click="doShowCreateAcctModal"
              >
                Create Account
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <!--      prompt user to input address-->
      <v-col
        v-else
        cols="12"
        sm="6"
      >
        <v-card
          flat
        >
          <p class="section-text">
            Enter your address starting with the street number in the box below
          </p>
          <v-row>
            <v-col
              cols="12"
            >
              <GmapAutocomplete
                ref="tbAutocomplete"
                class="search-location"
                @place_changed="onPlaceChanged"
              >
              </GmapAutocomplete>
            </v-col>
            <v-col
              v-if="searchErrors.length > 0"
            >
              <v-alert
                text
                v-for="(error, i) in searchErrors"
                :key="i"
                color="deep-orange"
              >
                <b>{{error}}</b>
              </v-alert>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <!--      AP Coverage-->
      <v-col
        cols="12"
        sm="6"
      >
        <v-row>
          <v-col
            cols="12"
          >
            <div class="section-subheader text-center">
              AP Coverage
            </div>
          </v-col>
          <v-col>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Tower
                  </th>
                  <th class="text-left">
                    AP
                  </th>
                  <th class="text-left">
                    Distance
                  </th>
                  <th class="text-left">
                    Type
                  </th>
                  <th class="text-left">
                    Subscribers
                  </th>
                  <th class="text-left">
                    Plans
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                  v-for="item in apCoverage"
                  :key="item.id"
                >
                  <td>{{ item.tower }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.distance }}</td>
                  <td>{{ item.type }}</td>
                  <td>{{ item.subscriberCount }} / {{ item.maxSubs ? item.maxSubs : '0' }}</td>
                  <td>{{ item.planString }}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row
      class="d-flex flex-column"
    >
      <v-card
        flat
        class="px-sm-5 mt-3 mb-6 card-full-width outline-pink"
      >
        <l-map
          id="map"
          ref="vwFootMap"
          style="height: 345px; width: inherit;z-index: 0"
          :zoom.sync="zoom"
          no-blocking-animations
          :center.sync="center"
          @click="onMapClicked"
        >
          <l-control-layers
            position="topright"
          ></l-control-layers>
          <l-tile-layer
            v-for="layer in tileProviders"
            :key="layer.name"
            :url="layer.url"
            :visible="layer.visible"
            :name="layer.name"
            layer-type="base"
          >
          </l-tile-layer>
          <l-marker
            :lat-lng="locationMarker"
            :options.sync="vwFootMarkerOptions"
          >
            <l-icon
              :icon-anchor="staticAnchor"
            >
              <img src="https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png">
            </l-icon>
          </l-marker>
        </l-map>
      </v-card>
    </v-row>
    <!--           Create Account Modal-->
    <v-dialog
      v-model="modalCreateAccount"
      max-width="600px"
    >
      <base-tile-card>
        <template v-slot:heading>
          Create Account
        </template>
        <v-row
          style="width:90%"
          class="mx-auto"
        >
          <v-col cols="12">
            <v-select
              v-model="newAccount.storeid"
              :items="optsStores"
            >
              <template v-slot:label>
                <div class="lbl-lg-textbox">
                  Store
                </div>
              </template>
            </v-select>
          </v-col>
          <v-col
            cols="6"
          >
            <v-text-field
              v-model="newAccount.firstName"
            >
              <template v-slot:label>
                <div class="lbl-lg-textbox">
                  First Name
                </div>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="newAccount.lastName"
            >
              <template v-slot:label>
                <div class="lbl-lg-textbox">
                  Last Name
                </div>
              </template>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="newAccount.email"
            >
              <template v-slot:label>
                <div class="lbl-lg-textbox">
                  Email
                </div>
              </template>
            </v-text-field>

          </v-col>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="newAccount.phone"
            >
              <template v-slot:label>
                <div class="lbl-lg-textbox">
                  Phone
                </div>
              </template>
            </v-text-field>

          </v-col>
          <v-col
            cols="12"
          >
            <v-textarea
              v-model="newAccount.comment"
            >
              <template v-slot:label>
                <div class="lbl-lg-textbox">
                  Comment
                </div>
              </template>
            </v-textarea>
          </v-col>
          <v-col
            v-if="createErrors.length > 0"
          >
            <v-alert
              text
              v-for="(error, i) in createErrors"
              :key="i"
              color="deep-orange"
            >
              <b>{{error}}</b>
            </v-alert>
          </v-col>
        </v-row>
        <template>
          <v-btn
            color="blue darken-1"
            class="mr-6"
            text
            @click="modalCreateAccount = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            class="mr-12"
            text
            @click="doStaffSignup"
          >
            Create Account
          </v-btn>
        </template>
      </base-tile-card>
      <v-overlay :value="overlayCreatingAccount">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </v-dialog>

  </v-container>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import {
    PUBLIC_PROCESS_GOOGLE_PLACE,
    PUBLIC_GET_PLANS, _COMMIT_LOG,
  } from '../../../store/actions.types'
  import {
    SIGNUP_RESET_LOCATION,
    SIGNUP_SET_SELECTED_PLAN,
  } from '../../../store/mutations.types'
  import { LControlLayers, LIcon, LMap, LMarker, LTileLayer } from 'vue2-leaflet'
  import 'leaflet/dist/leaflet.css'
  import LocationService from '../../../services/location.service'
  import SignupService from '../../../services/signup.service'
  import basicMixin from '../../../mixins/basic'

  export default {
    name: 'Plans',
    components: {
      // VueGoogleAutocomplete,
      // PowAutocompleteMap,
      'l-map': LMap,
      // 'l-geo-json': LGeoJson,
      'l-tile-layer': LTileLayer,
      'l-marker': LMarker,
      // 'l-layer-group': LLayerGroup,
      'l-control-layers': LControlLayers,
      'l-icon': LIcon,
      // 'l-wms-tile-layer': LWMSTileLayer,
      // 'l-tooltip': LTooltip,
    },
    mixins: [basicMixin],

    data () {
      return {
        tileProviders: [
          {
            name: 'Satellite Mapbox Base',
            visible: true,
            attribution: '',
            url: 'https://api.mapbox.com/styles/v1/jdietrich/ckb86tww8021u1imi6yc0j0up/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiamRpZXRyaWNoIiwiYSI6ImNrYjdjOTY4YTA0ZGIzMHM3MDVtYW54dHMifQ.G39kMitwQre3y48CHIGhwQ',
          },
        ],
        zoom: 12,
        radius: 3,
        center: [37.79442939780746, -120.9921788731105],
        vwFootMarkerOptions: {
          riseOnHover: true,
        },
        markerDetails: {
          lat: 37.794603,
          lng: -120.99223,
        },
        locationMarker: {
          lat: 37.794603,
          lng: -120.99223,
        },
        markerConfirmed: false,
        modalCreateAccount: false,
        overlayCreatingAccount: false,
        staticAnchor: [12, 41],
        searchErrors: [],
        createErrors: [],
        apCoverage: [],
        newAccount: {
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          comment: '',
          storeid: 1,
        },
      }
    },
    computed: {
      ...mapGetters(['publicPlans', 'optsStores']),
      ...mapGetters({
        publicLocation: 'signupLocation',
        publicAvailablePlans: 'signupAvailablePlans',
      }),
      calculatedStreet: function () {
        return this.publicLocation.street_number + ' ' + this.publicLocation.route
      },
      hasLocation: function () {
        if (this.publicLocation.street_number &&
          this.publicLocation.street_number.length > 0 &&
          this.publicLocation.lat &&
          this.publicLocation.lng) {
          return true
        }
        return false
      },
    },
    watch: {
      publicLocation (n, o) {
        console.log('New Location:', n)
        if (n.street_number &&
          n.street_number.length > 0 &&
          n.lat &&
          n.lng) {
          this.searchErrors = []
        } else if (n.lat &&
          n.lng) {
          this.searchErrors.push('Location must have a street number')
        }
      },
    },

    async created () {
      await this.init()
      await this.doGetCoverage(this.publicLocation)
    },
    methods: {
      ...mapActions({
        processPlaceChanged: PUBLIC_PROCESS_GOOGLE_PLACE,
        getPlans: PUBLIC_GET_PLANS,
        commitLog: _COMMIT_LOG,
      }),
      ...mapMutations({
        resetLocation: SIGNUP_RESET_LOCATION,
        selectPlan: SIGNUP_SET_SELECTED_PLAN,
      }),
      async init () {
        this.setMap()
        // await this.getPlans()
      },
      setMap () {
        if (this.publicLocation.street_number &&
          this.publicLocation.street_number.length > 0 &&
          this.publicLocation.lat &&
          this.publicLocation.lng) {
          this.center = [this.publicLocation.lat, this.publicLocation.lng]
          this.locationMarker = { lat: this.publicLocation.lat, lng: this.publicLocation.lng }
          this.zoom = 20
        } else {
          this.center = [37.79442939780746, -120.9921788731105]
          this.zoom = 12
        }
      },
      async onPlaceChanged (addressData) {
        // eslint-disable-next-line camelcase
        console.log('Place Changed', addressData)
        this.locationMarker = await this.processPlaceChanged(addressData)
        await this.doGetCoverage(this.locationMarker)
        this.init()
      },
      async doSelectPlan (plan) {
        console.log('Plan selected', plan)
        this.selectPlan(plan.value)
        this.$router.push('/signup')
      },
      async onMapClicked (event) {
        // console.log('map clicked event')
        // console.log(event)
        // this.locationMarker.lat = event.latlng.lat
        // this.locationMarker.lng = event.latlng.lng
        this.locationMarker = { lat: event.latlng.lat, lng: event.latlng.lng }
      },
      async doGetCoverage (location) {
        try {
          const { data } = await LocationService.checkCoverage(location)
          this.apCoverage = data._aps
          console.log(data)
        } catch (e) {
          console.log(e)
        }
      },
      async doResetLocation () {
        try {
          this.resetLocation()
          this.apCoverage = []
        } catch (e) {
          console.log(e)
        }
      },
      async doShowCreateAcctModal () {
        this.commitLog({ message: 'showing modal to create account' })
        this.modalCreateAccount = true
      },
      async doStaffSignup () {
        this.createErrors = []
        this.overlayCreatingAccount = true
        if (this.newAccount.firstName.length <= 1) {
          this.createErrors.push('First Name is required.')
        }
        if (this.newAccount.lastName.length <= 1) {
          this.createErrors.push('Last Name is required.')
        }
        if (this.newAccount.phone.length <= 1) {
          this.createErrors.push('Phone number is required.')
        }
        if (this.newAccount.email.length <= 1) {
          this.createErrors.push('Email is required.')
        }
        if (this.createErrors.length > 0) {
          this.overlayCreatingAccount = false
          return
        }
        const payload = {
          form_data: this.newAccount,
          location_key: this.publicLocation.rowkey,
        }
        try {
          const { data } = await SignupService.staffSignup(payload)
          this.commitLog({ message: 'payload from signup', payload: data })
          if (data && data.rowkey) {
            const url = `/#/staff/account/${data.rowkey}`
            window.open(url)
          }
          this.overlayCreatingAccount = false
        } catch (e) {
          if (e.response && e.response.data) {
            const { data } = e.response
            this.commitLog({ message: 'exception thrown ', error: data })
            this.createErrors = data.problems
          }
          this.overlayCreatingAccount = false
        }
        this.overlayCreatingAccount = false
      },
    },
  }
</script>
